import { render, staticRenderFns } from "./CommentsCountBtn.vue?vue&type=template&id=5a53a764&scoped=true"
import script from "./CommentsCountBtn.vue?vue&type=script&lang=js"
export * from "./CommentsCountBtn.vue?vue&type=script&lang=js"
import style0 from "./CommentsCountBtn.vue?vue&type=style&index=0&id=5a53a764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53a764",
  null
  
)

export default component.exports